export function timestamp() {
    return Math.round(performance.now()) + performance.timing.navigationStart;
}
export const stars = 'repeat' in String.prototype
    ? (str) => '*'.repeat(str.length)
    : (str) => str.replace(/./g, '*');
export function normSpaces(str) {
    return str.trim().replace(/\s+/g, ' ');
}
export function isURL(s) {
    return s.substr(0, 8) === 'https://' || s.substr(0, 7) === 'http://';
}
export const IN_BROWSER = !(typeof window === "undefined");
